import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { MasterDataService } from '../../../secure/master-data/_services/master-data.service';
import * as CountryActions from '../../actions/master-data/country.actions';

@Injectable()
export class CountryEffects {
  constructor(
    private actions$: Actions,
    private masterDataService: MasterDataService
  ) {}

  loadCountries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CountryActions.loadCountries),
      mergeMap(() =>
        this.masterDataService.getAllCountries().pipe(
          map((countries) => CountryActions.loadCountriesSuccess({ countries })),
          catchError((error) => {
            let errorMessage = 'An error occurred loading ountries.';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(CountryActions.loadCountriesFailure({ error: errorMessage }));
          })
        )
      )
    )
  );

  addCountry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CountryActions.addCountry),
      mergeMap(({ country }) =>
        this.masterDataService.addNewCountry(country).pipe(
          mergeMap(saved => [
            CountryActions.addCountrySuccess({
              country: saved,
              message: 'Country created successfully'
            }),
            CountryActions.loadCountries()
          ]), catchError((error) => {
            let errorMessage = 'An error occurred while adding country.';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(CountryActions.loadCountriesFailure({ error: errorMessage }));
          })
        )
      )
    )
  );

  updateCountry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CountryActions.updateCountry),
      mergeMap(({ country }) =>
        this.masterDataService.updateCountry(country).pipe(
          mergeMap(saved => [
            CountryActions.updateCountrySuccess({
              country: saved,
              message: 'Country updated successfully'
            }),
            CountryActions.loadCountries()
          ]), catchError((error) => {
            let errorMessage = 'An error occurred while updating country.';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(CountryActions.loadCountriesFailure({ error: errorMessage }));
          })
        )
      )
    )
  );  

  deleteCountry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CountryActions.deleteCountry),
      mergeMap(({ id }) =>
        this.masterDataService.deleteCountry(id).pipe(
          mergeMap(() => [
            CountryActions.deleteCountrySuccess({
              message: 'Country deleted successfully'
            }),
            CountryActions.loadCountries()
          ]), catchError((error) => {
            let errorMessage = 'An error occurred while deleting country.';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(CountryActions.loadCountriesFailure({ error: errorMessage }));
          })
        )
      )
    )
  );
  
}